/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Button, Col, Form, Modal, Row, Select, Space, Table, Tabs } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import axios from "axios"
import { useLocation } from "react-router-dom"
import styles from "../filing.module.css"
import { PreviewImgOrPdf } from "../Preview"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { EditableList } from "../../../compnents/list/EditableList"
import { SSJSSTemporaryColumns } from "../columns"
import { AXIOS_IP, exportPdf } from "../fileUploadService"

export const SSJSSDetail = () => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [form] = Form.useForm()

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [token, setToken] = useState("")

  const [pageLoading, setPageLoading] = useState(false)

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
    sameNameProcurementCount: "",
    isAdjustment: -1,
  })

  const [params, setParams] = useState<any>({
    pageNo: 1,
    pageSize: 10,
  })

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    setPageLoading(true)
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url: location.state?.state == 2 ? `${AXIOS_IP}/reviewSurgicalDirectoryRecord/detail` : `${AXIOS_IP}/filingSurgicalDirectory/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: {
            id: location.state?.id,
            ...params,
          },
        })
          .then((res) => {
            const data = res.data.data
            setPage({
              items: data?.list || [],
              total: data?.total || 0,
            })
          })
          .finally(() => setPageLoading(false))
      })
  }

  useEffect(() => {
    getData()
  }, [params])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "三四级手术目录报备详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.type },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { id: location.state?.id },
                      token,
                      path: "/filingSurgicalDirectory/generatePdf",
                      fileName: "三四级手术目录报备详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Row
          style={{
            margin: "10px 0 20px",
            fontSize: "17px",
            fontWeight: "bold",
          }}
        >
          三四级手术目录报备详情
        </Row>
        <Form form={form}>
          <Form.Item
            label="报备表"
            name="fileData"
            rules={[{ required: true }]}
          >
            {location.state?.fileData?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
        </Form>
        <EditableList
          style={{ flex: 1 }}
          scroll={{ x: "30rem" }}
          page={{
            items: page.items,
            current: params.pageNo,
            size: params.pageSize,
            total: page.total,
          }}
          pageSizeOptions={["10", "20", "50", "100"]}
          loading={pageLoading}
          rowKey={(m: any) => m.id}
          columns={SSJSSTemporaryColumns(params.pageSize * (params.pageNo - 1))}
          onChangePage={(current, size) =>
            setParams({ ...params, pageNo: current, pageSize: size || 10 })
          }
          sticky
        />
      </div>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
